export class QuienesSomos {
    constructor() {
        this.content = [];
        this.description = '';
        this.name = '';
    }
}